module.exports = __webpack_public_path__ + "img/oldImage.dab858ac.svg";